import i18n from 'i18next';
import { IFooterProps } from '../../interfaces';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';


export default function Footer(props: IFooterProps): JSX.Element {
    const { language } = i18n;
    const { t } = useTranslation();

    const _isRuLng: boolean = language === 'ru';

    const [ hiddenElem, setHiddenElem ] = useState<string[]>([]);
    const [ className, setClassName ] = useState<string>('footer');

    useEffect((): void => {
        if (props.hiddenElems?.length) {
            setHiddenElem(props.hiddenElems);
        }

        if (props.className) {
            setClassName(props.className);
        }
    }, []);

    const _navigate = (fileName: string): void => {
        window.location.href = `${window.location.origin}/docs/${fileName}.html`;
    }

    return (
        <div className={className} id="footer">
            {
                !hiddenElem.includes('llc') ?
                    <span className="footer-llc">
                        &#169;
                        &nbsp;
                        {new Date().getFullYear()}
                        &nbsp;
                        {t('footer.llc', {lng: language === 'ru' ? 'ru' : 'en'})}
                    </span>
                    : null
            }
            <div className="footer-wrapper">
                {
                    !hiddenElem.includes('contacts') ?
                        <span
                            className="footer-wrapper-elem"
                            onClick={() => _navigate(`${_isRuLng ? 'Ru' : 'En'}Contacts`)}
                        >
                            {t('footer.contacts', {lng: _isRuLng ? 'ru' : 'en'})}
                        </span>
                        : null
                }
                {
                    !hiddenElem.includes('offer') ?
                        <span
                            className="footer-wrapper-elem footer-offer"
                            onClick={() => _navigate(`${_isRuLng ? 'Ru' : 'En'}PublicOffer`)}
                        >
                            {t('footer.offer', {lng: _isRuLng ? 'ru' : 'en'})}
                        </span>
                        : null
                }
                {
                    !hiddenElem.includes('terms') ?
                        <span
                            className="footer-wrapper-elem"
                            onClick={() => _navigate('EnTermsOfUse')}
                        >
                            {t('footer.terms', {lng: _isRuLng ? 'ru' : 'en'})}
                        </span>
                        : null
                }
                {
                    !hiddenElem.includes('privacy') ?
                        <span
                            className="footer-wrapper-elem"
                            onClick={() => _navigate(`${_isRuLng ? 'Ru' : 'En'}PrivacyPolicy`)}
                        >
                            {t('footer.privacy', {lng: _isRuLng ? 'ru' : 'en'})}
                        </span>
                        : null
                }
                {
                    !hiddenElem.includes('personalData') ?
                        <span
                            className="footer-wrapper-elem footer-personalData"
                            onClick={() => _navigate(`${_isRuLng ? 'Ru' : 'En'}PersonalData`)}
                        >
                            {t('footer.personalData', {lng: _isRuLng ? 'ru' : 'en'})}
                        </span>
                        : null
                }
            </div>
        </div>
    );
}